import { Action } from 'redux';

enum ActionType {
  OpenWarningDialogAction = 'WarningDialog.OpenWarningDialogAction',
  CloseWarningDialogAction = 'WarningDialog.CloseWarningDialogAction',
  TriggeredByNewSelectionAction = 'WarningDialog.TriggeredByNewSelectionAction',
  ResetTriggeredByNewSelectionAction = 'WarningDialog.ResetTriggeredByNewSelectionAction',
  ReturnToEditAction = 'WarningDialog.ReturnToEditAction',
  ResetReturnToEditAction = 'WarningDialog.ResetReturnToEditAction',
}

interface IWarningDialogAction extends Action<ActionType> {
  payload: any;
}

const INITIAL_STATE = {
  isWarningDialogOpened: false,
  triggeredByNewSelection: false,
  returnToEdit: true,
};

type IWarningDialog = typeof INITIAL_STATE;

export default (state: IWarningDialog = INITIAL_STATE, action: IWarningDialogAction) => {
  switch (action.type) {
    case ActionType.OpenWarningDialogAction:
      return { ...state, isWarningDialogOpened: true };
    case ActionType.CloseWarningDialogAction:
      return { ...state, isWarningDialogOpened: false };
    case ActionType.TriggeredByNewSelectionAction:
      return { ...state, triggeredByNewSelection: true };
    case ActionType.ResetTriggeredByNewSelectionAction:
      return { ...state, triggeredByNewSelection: false };
    case ActionType.ReturnToEditAction:
      return { ...state, returnToEdit: true };
    case ActionType.ResetReturnToEditAction:
      return { ...state, returnToEdit: false };
    default:
      return state;
  }
};

export const openWarningDialog = () => ({
  type: ActionType.OpenWarningDialogAction,
});

export const closeWarningDialog = () => ({
  type: ActionType.CloseWarningDialogAction,
});

export const triggeredByNewSelection = () => ({
  type: ActionType.TriggeredByNewSelectionAction,
});

export const resetTriggeredByNewSelection = () => ({
  type: ActionType.ResetTriggeredByNewSelectionAction,
});

export const returnToEdit = () => ({
  type: ActionType.ReturnToEditAction,
});

export const resetReturnToEdit = () => ({
  type: ActionType.ResetReturnToEditAction,
});
